module.exports = __webpack_public_path__ + "img/rnd-mobile-banner.3cabc6af.png";